import _ from "lodash";
import { useCallback } from "react";
import { Box, Grid } from "@mui/material";
import FilterIcon from "../../icons/FilterIcon";
import GridIcon from "../../icons/GridIcon";
import ListIcon from "../../icons/ListIcon";
import Button from "../../toolkit/ButtonV1";
import FormControl from "../../components/FormControl";
import { useState } from "react";
import { useEffect } from "react";
import GridViewIcon from '@mui/icons-material/GridView';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';

const searchDebounceDelay = 1000;

export default function ({
  searchStr: parentSearchStr,
  setSearchStr: parentSetSearchStr,
  viewType,
  toggleViewType,
  openSlidingPopup,
  largeScreen,
  setClientId,
  clientId,
  allClients,
  ClosePo,
  ID,
  OpenFilterTab
}) {
  const [searchStr, setSearchStr] = useState(parentSearchStr);
  const debouncedSearchQueryHandler = useCallback(
    _.debounce(parentSetSearchStr, searchDebounceDelay),
    []
  );

  useEffect(() => {
    if (parentSearchStr !== searchStr) {
      debouncedSearchQueryHandler(searchStr);
    }
  }, [searchStr]);


  //Open Advance Filters Tab
  useEffect(() => {
    if (ID == 1) {
      openSlidingPopup()
      OpenFilterTab(1);

      const newURL = window.location.pathname + `?clientId=${clientId}`;
      window.history.pushState({}, "", newURL);
    }
  }, []);
  //

  return (
    <Box className="collection-controls">

      <FormControl
        inputType="text"
        placeholder="Search vendor"
        value={searchStr}
        handleChange={setSearchStr}
      />
      <Box flexGrow="1" />
      <FormControl
        inputType="select"
        placeholder="Select client"
        items={allClients}
        value={clientId}
        handleChange={setClientId}
        multiple={false}
        style={{ float: "right" }}
      />
      <Button
        role="tertiary"
        size="default"
        label="Filters"
        trailingComponent={<FilterIcon />}
        onClick={() => {
          openSlidingPopup()
          ClosePo(false)
        }}
      />
      {largeScreen && (
        <Button
          role="tertiary"
          size="large"
          // trailingComponent={viewType === "list" ? <GridIcon /> : <ListIcon />}
          trailingComponent={viewType === "list" ? <GridViewIcon sx={{ color: "#adb2bd", fontWeight: "300", fontSize: "18px" }} /> : <SplitscreenIcon sx={{ color: "#adb2bd", fontWeight: "400", fontSize: "18px" }} />}
          onClick={toggleViewType}
        />
      )}


    </Box>
  );
}
